module.exports = __webpack_public_path__ + "img/english-translate.efcaa257.svg";